
export enum ChatSteps {
  personName = 'personName',
  gender = 'gender',
  motherName = 'motherName',
  description = 'description',
  image = 'image',
  video = 'video',
  confirmation = 'confirmation',
  loader = 'loader',
  final = 'final',
}

export type MediaType = 'image' | 'video';

export type BotChatMessage = {
  id: string;
  role: 'bot';
  text: string;
};

export type TextUserChatMessage = {
  id: string;
  role: 'user';
  type: 'text';
  text: string;
};

export type MediaUserChatMessage = {
  id: string;
  role: 'user';
  type: 'media';
  mediaType: 'image' | 'video';
  url: string;
  fileName?: string;
};

export type ChatMessage = BotChatMessage | TextUserChatMessage | MediaUserChatMessage;

export 
type UserMessagePayload =
  | { type: 'text'; text: string }
  | { type: 'media'; mediaType: 'image' | 'video'; url: string; fileName?: string };